import { render, staticRenderFns } from "./PartnerSection.vue?vue&type=template&id=45f50982&"
import script from "./PartnerSection.vue?vue&type=script&lang=js&"
export * from "./PartnerSection.vue?vue&type=script&lang=js&"
import style0 from "./PartnerSection.vue?vue&type=style&index=0&id=45f50982&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports